
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Twitter } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <footer className="py-16 bg-gradient-to-r from-primary/90 via-purple-600/90 to-primary/90 text-white border-t">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="mb-8 md:mb-0">
            <h2 className="text-lg font-bold mb-4">Offertio</h2>
            
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-white/80 hover:text-white transition-colors"><Twitter size={20} /></a>
              <a href="#" className="text-white/80 hover:text-white transition-colors"><Linkedin size={20} /></a>
              <a href="#" className="text-white/80 hover:text-white transition-colors"><Instagram size={20} /></a>
            </div>
            
            <div className="mt-4 text-white/90">
              <p className="my-[25px]"><a href="mailto:info@offertio.dk" className="hover:text-white hover:glow-sm transition-all">info@offertio.dk</a></p>
              <p className="py-0 my-0">CVR: 43469754</p>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-white/80 tracking-wider uppercase mb-4">
              {t('footer.platform.title')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/platform/agent" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('nav:agent')}
                </Link>
              </li>
              <li>
                <Link to="/platform/data-integration" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.platform.integration')}
                </Link>
              </li>
              <li>
                <Link to="/platform/translations-analysis" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.platform.translation')}
                </Link>
              </li>
              <li>
                <Link to="/platform/legal-assistance" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('nav:legalAssistance')}
                </Link>
              </li>
              <li>
                <Link to="/platform/market-analysis-opportunities" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('nav:competitors')}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-white/80 tracking-wider uppercase mb-4">
              {t('footer.company.title')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.company.about')}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.company.pricing')}
                </Link>
              </li>
              <li>
                <Link to="/request-demo" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.company.contact')}
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-white/80 tracking-wider uppercase mb-4">
              {t('footer.support.title')}
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/legal/privacy-policy" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.legal.privacy')}
                </Link>
              </li>
              <li>
                <Link to="/legal/terms-of-service-danish" className="text-white/90 hover:text-white hover:glow-sm transition-all text-sm">
                  {t('footer.legal.terms')}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-white/20">
          <p className="text-white/70 text-sm text-center">{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};
